import { POLLING_TIME_LIMIT_IN_MIN } from '../../config/Config';
import { DatasetFileVersion } from '../../types/dataset';
import { Run } from '../../types';

export const anyRecentProcessingDatasetFileVersion = (fileList: DatasetFileVersion[]) => {
  const anyRecentProcessingInference =
    fileList && fileList.find(file => isRecentAndProcessingInference(file.datasetFile));
  return !!anyRecentProcessingInference;
};

export const anyRecentProcessingInference = (inferenceList: { status: string; timeCreated: string }[]) => {
  const anyRecentProcessingInference =
    inferenceList && inferenceList.find(inference => isRecentAndProcessingInference(inference));
  return !!anyRecentProcessingInference;
};

export const isRecentAndProcessingInference = (inference: { timeCreated: string; status: string; run?: Run }) => {
  return (
    hasProcessingStatus(inference) &&
    new Date().getTime() - new Date(inference.timeCreated).getTime() < POLLING_TIME_LIMIT_IN_MIN * 60000
  );
};

export const hasProcessingStatus = (inference: { status: string; run?: Run }) => {
  return (
    inference &&
    ((inference.run && (inference.run.status === 'PROCESSING' || inference.run.status === 'PREP_FINISHED')) ||
      inference.status === 'PROCESSING' ||
      inference.status === 'PREP_FINISHED')
  );
};
